import React from "react";

function Experience(){
    return(
        <div className="expcontainer">
            <div  className="container3" >
                <div><p style={{color:"white", fontSize:"18px"}}>2023-Now</p></div>
                <div>
                    <p style={{color:"white", fontSize:"18px"}}>Oracle</p>
                    <p>Associate Consultant</p>
                </div>
            </div>
            <div  className="container3" >
                <div><p style={{color:"white", fontSize:"18px"}}> 2022-2023</p></div>
                <div>
                    <p style={{color:"white", fontSize:"18px"}}>TGH</p>
                    <p>Flutter Developer Intern</p>
                </div>
            </div>
            <div  className="container3" >
                <div><p style={{color:"white", fontSize:"18px"}}>2022-2023</p></div>
                <div>
                    <p style={{color:"white", fontSize:"18px"}}>IEDC</p>
                    <p>WIE Lead</p>
                </div>
            </div>    
        </div>
    )
}

export default Experience;